import { z } from "zod";

const scopeSchema = z.enum(["read", "write", "admin"]);

export const createApiKeySchema = z.object({
  name: z.string().min(1, "Name is required").max(255, "Name must be less than 255 characters"),
  scopes: z.array(scopeSchema).min(1, "At least one scope is required"),
});

export const updateApiKeySchema = z.object({
  name: z
    .string()
    .min(1, "Name is required")
    .max(255, "Name must be less than 255 characters")
    .optional(),
  scopes: z.array(scopeSchema).min(1, "At least one scope is required").optional(),
});

export type CreateApiKeyFormData = z.infer<typeof createApiKeySchema>;
export type UpdateApiKeyFormData = z.infer<typeof updateApiKeySchema>;
